module.exports = __webpack_public_path__ + "img/a4.68cbbfec.svg";